import { render } from "./PostDetail.vue?vue&type=template&id=0b6e2438&scoped=true"
import script from "./PostDetail.vue?vue&type=script&lang=js"
export * from "./PostDetail.vue?vue&type=script&lang=js"

import "./PostDetail.vue?vue&type=style&index=0&id=0b6e2438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6e2438"]])

export default __exports__